module.exports = __webpack_public_path__ + "cd7296352d159532b66c07d98efb1126.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/Regular/OpenSans-Regular.ttf?v=1.1.0
// module id = 985
// module chunks = 0